export default "/images/img-1.jpg?c8a39a7a50ed65dd7307c4a91195a71c";